module.exports = __webpack_public_path__ + "static/carpoolchella-cta-1-9ec2b45c9600478ed554fcccc25a8b6f.jpg";